export default (theme) => ({
  chatThread: {
    width: 'calc(100% / 12 * 8)',
    height: '100%',
    backgroundColor: theme.palette.background.white,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    borderRadius: 33,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  lineWrapper: {
    height: 'calc(100% - 20px)',
    padding: '5px 27px',
    overflow: 'auto',
  },
  controls: {
    margin: 'auto 0 0',
    padding: '15px 46px 45px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '5px 20px 20px',
      alignItems: 'flex-start',
    },
  },
  extendedControls: {
    padding: '60px 46px 45px',
    [theme.breakpoints.down('sm')]: {
      padding: '60px 20px 20px',
    },
  },
  attachmentsBox: {
    background: theme.palette.background.white,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'absolute',
    bottom: '100%',
    left: 0,
    border: '1px solid',
    borderBottom: 'none',
    borderColor: theme.palette.disabled.main,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    padding: '10px 10px 5px',
    height: 60,
    width: '100%',
  },
  scrollWrap: {
    minWidth: 'initial',
    display: 'flex',
    alignItems: 'center',
    overflow: 'auto',
    overflowY: 'hidden',
    height: 45,
    paddingBottom: 2,
  },
  attachment: {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 'max-content',
    marginRight: 10,
    height: 35,
  },
  attachmentText: {
    minWidth: 'max-content',
    width: 'max-content',
    display: 'block',
    fontStyle: 'italic',
    color: theme.palette.disabled.main,
  },
  header: {
    position: 'relative',
    height: 97,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.disabled.main}`,
  },
  backButton: {
    position: 'absolute',
    top: 10,
    left: 15,
    padding: 15,
    background: 'none',
    border: 'none',
    [theme.breakpoints.down('md')]: {
      padding: '15px 0',
    },
  },
  title: {
    fontSize: 22,
    margin: 'auto',
    textAlign: 'center',
    padding: '0 10px',
    width: '70%',
    textTransform: 'capitalize',
  },
  attachFile: {
    padding: 0,
    background: 'none',
    border: 'none',
    maxWidth: 45,
    height: 45,
    maxHeight: 45,
    width: '100%',
    '& input': {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 40,
      height: 40,
      maxHeight: 40,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 35,
      height: 35,
      maxHeight: 35,
    },
    '& svg': {
      width: '100%',
      height: '100%',
      cursor: 'pointer',
    },
  },
  sendBtn: {
    pointerEvents: 'none',
    cursor: 'pointer',
    background: theme.palette.disabled.main,
    border: 'none',
    maxWidth: 56,
    minHeight: 56,
    maxHeight: 56,
    height: '100%',
    width: '100%',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      maxWidth: 40,
      minHeight: 40,
      maxHeight: 40,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 33,
      minHeight: 33,
      maxHeight: 33,
    },
    '& svg': {
      width: '60%',
    },
  },
  sendBtnActive: {
    pointerEvents: 'initial',
    background: theme.palette.primary.main,
  },
  messageInput: {
    position: 'relative',
    width: '100%',
    margin: '0 20px',
  },
  messageInputActive: {
    '& fieldset': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  },
  thread: {
    paddingTop: 50,
  },
  caption: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
  },

  // message
  messagesWrapper: {
    marginTop: 10,
    display: 'flex',
  },
  userMessagesWrapper: {
    flexDirection: 'row-reverse',
  },
  userMessageWithoutAvatar: {
    marginTop: 0,
  },
  videoChatAvatar: {
    minWidth: 40,
    margin: '0 15px 0 0',
    '& .MuiAvatar-root': {
      width: 40,
      height: 40,
      [theme.breakpoints.down('sm')]: {
        width: 33,
        height: 33,
      },
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 35,
      margin: '0 10px 0 0',
      '& div': {
        fontSize: 14,
      },
    },
  },
  avatar: {
    minWidth: 60,
    margin: '0 15px 0 0',
    '& .MuiAvatar-root': {
      width: 58,
      height: 58,
      [theme.breakpoints.down('md')]: {
        width: 41,
        height: 41,
      },
      [theme.breakpoints.down('sm')]: {
        width: 33,
        height: 33,
      },
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 35,
      margin: '0 10px 0 0',
      '& div': {
        fontSize: 14,
      },
    },
  },
  userAvatar: {
    margin: '0 0 0 30px',
    [theme.breakpoints.down('md')]: {
      margin: '0 0 0 14px',
    },
  },
  sender: {
    fontWeight: 'bold',
    position: 'absolute',
    bottom: 'calc(100% + 10px)',
    width: 'max-content',
  },
  userMessageInfoSenderWrapper: {
    paddingTop: 10,
  },
  message: {
    padding: '13px 20px',
    boxSizing: 'border-box',
    borderRadius: 39,
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    '& span': {
      color: theme.palette.font.main,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
    whiteSpace: 'pre-wrap',
  },
  userMessage: {
    backgroundColor: theme.palette.primary.main,
    '& span': {
      color: theme.palette.background.default,
    },
  },
  date: {
    paddingTop: 8,
    margin: 'auto 0 0 30px',
    color: theme.palette.font.main,
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
      margin: 'auto 0 0 14px',
    },
  },
  userDate: {
    margin: 'auto 30px 0 0',
    [theme.breakpoints.down('md')]: {
      margin: 'auto 14px 0 0',
    },
  },
  messageInfoWrapper: {
    marginBottom: 10,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  userMessageInfoWrapper: {
    alignItems: 'flex-end',
    width: 'calc(100% - 75px)',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 50px)',
    },
  },
  messageAttachment: {
    marginTop: 10,
  },
  chatEndedMessage: {
    margin: '0 auto',
    padding: 10,
    textAlign: 'center',
  },

  // messages

  chatMessages: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  currentSectionDate: {
    textAlign: 'center',
    margin: '0 auto',
    width: '100%',
    marginBottom: 20,
  },
});
